import { render, staticRenderFns } from "./returnTheGoods.vue?vue&type=template&id=20023b0d&scoped=true&"
import script from "./returnTheGoods.vue?vue&type=script&lang=ts&"
export * from "./returnTheGoods.vue?vue&type=script&lang=ts&"
import style0 from "./returnTheGoods.vue?vue&type=style&index=0&id=20023b0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20023b0d",
  null
  
)

export default component.exports